// eslint-disable-next-line @typescript-eslint/no-use-before-define
import { Image, UserAccount } from 'lego-on-react';
import React from 'react';
import { useLocation } from 'react-router-dom';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Header';
import block from 'propmods';

import { routes } from '../../lib/routes';
import { getIsGlobalViewer, getShowMailAnnouncement, isIframe } from '../../utils';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import Link from '../Link/Link';
import UserSettings from '../UserSettingsPopup/UserSettingsPopup';

import LegoHeader from './LegoHeader';

import './Header.scss';

const t = i18n(keyset);

const b = block('Header');

const Header = () => {
    const { passport, user } = __appConfig;
    const { pathname, search } = useLocation();
    const href = encodeURIComponent(window.location.origin + pathname + search);
    const theme = user && user.isAdmin ? 'danger' : getIsGlobalViewer() ? 'viewer' : 'normal';
    const yaIconUrl = `https://yastatic.net/q/logoaas/v1/${encodeURIComponent(t('yandex'))}.svg?size=29.5&color=000`;
    const dialogsIconUrl = `https://yastatic.net/q/logoaas/v1/${encodeURIComponent(
        t('dialogs'),
    )}.svg?size=29.5&color=000`;

    if (isIframe()) {
        return null;
    }

    const isYangoRequest = __appConfig.isYangoRequest;

    // Priemka always should uses Yandex passport because yandex.ru host
    // Passport link enforced via PASSPORT_YANGO_API=passport.yandex.ru env var
    const passportLink = `${passport}?retpath=${href}`;

    return (
        <ErrorBoundary>
            <div {...b({}, { theme })}>
                <div {...b('content')}>
                    <LegoHeader>
                        <LegoHeader.Main>
                            {isYangoRequest ? (
                                <div {...b('yango-logo')}>
                                    <Link to={routes.app.root}>
                                        <img src={routes.app.assets('images/yango.svg')} />
                                    </Link>
                                </div>
                            ) : (
                                <LegoHeader.Logo size="m">
                                    <img {...b('dev-logo')} src={routes.app.assets('images/dev.svg')} />
                                    <Link to="https://ya.ru">
                                        <Image url={yaIconUrl} />
                                    </Link>
                                    &nbsp;
                                    <Link to={routes.app.root}>
                                        <Image url={dialogsIconUrl} />
                                    </Link>
                                </LegoHeader.Logo>
                            )}
                            {user && (
                                <LegoHeader.Right>
                                    {getShowMailAnnouncement() && <UserSettings padRight />}
                                    <UserAccount
                                        hasAccentLetter
                                        pic
                                        avatarId={user.blackbox.avatar?.default}
                                        name={user.blackbox.displayName}
                                        url={passportLink}
                                    />
                                </LegoHeader.Right>
                            )}
                        </LegoHeader.Main>
                    </LegoHeader>
                </div>
            </div>
        </ErrorBoundary>
    );
};

export default Header;
